// tslint:disable
import axios from "axios"
import { User } from "../models/user.model";
import { BaseService } from "./base.service";

class UserService extends BaseService {

    constructor(){
        super();
        console.log("created a instance of UserService");
    }

    async delete(id: number){
        let result = await axios.delete(`${this.api}user/DeleteUser?id=${id}`);
        return result;
        // return this.execute('delete', `user/${id}`);
    }

    async getAll(getAllCommand:any){
        return axios.get(`${this.api}user/GetUserListWithThumbnail?companyId=${getAllCommand}`).then(req => { return req.data; });
    }

    async getAllKeyValue(query:any){
        return axios.get(`${this.api}user/GetKeyValueList?companyId=${query}`).then(req => { return req.data });
        // return this.execute('get', 'pinboard/');
    }

    async getCount(){
        return axios.get(`${this.api}user/count`).then(req => { return req.data; });
    }

    async get(id: number){
        return axios.get(`${this.api}user/Get?id=${id}`).then(req => { return req.data; });
    }

    async getDetails(id: number){
        return axios.get(`${this.api}user/GetDetail?id=${id}`).then(req => { return req.data; });
    }

    async create(user: User){
        let result = await axios.post(`${this.api}user/CreateUser`, user);
        return result;
    }

    async update(user: User){
        let result = await axios.put(`${this.api}user/UpdateUser`, user);
        return result;
    }

    async updateUserPassword(updateUserPasswordCommand:any){
        let result = await axios.put(`${this.api}user/UpdateUserPassword`, updateUserPasswordCommand);
        return result;
    }

    async setAvailability(user: User) {
        let result = await axios.put(`${this.api}user/availability/`, user);
        return result;
    }

    async getAllByPinBoardId(pinboardId: number){
        return axios.get(`${this.api}user/pinboard/${pinboardId}`).then(req => { return req.data; });
    }

    async createImage(formData:FormData, userId:number){
        return axios.post(`${this.api}user/CreateImage/?userId=${userId}`, 
        formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then(req => { return req.data });
    }

    async updateImage(formData:FormData, userId:number){
        return axios.put(`${this.api}user/UpdateImage/?userId=${userId}`, 
        formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then(req => { return req.data });
    }
}

export const userService = new UserService();

